export const availableSouthernCaliforniaCounties = [
  'Imperial',
  'Kern',
  'Los Angeles',
  'Orange',
  'Riverside',
  'San Bernardino',
  'San Diego',
  'San Luis Obispo',
  'Santa Barbara',
  'Ventura'
];
